import { render, staticRenderFns } from "./EntityHoldings.vue?vue&type=template&id=7087925b&scoped=true&"
import script from "./EntityHoldings.vue?vue&type=script&lang=js&"
export * from "./EntityHoldings.vue?vue&type=script&lang=js&"
import style0 from "./EntityHoldings.vue?vue&type=style&index=0&id=7087925b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087925b",
  null
  
)

export default component.exports